import {FC} from "react";
import {AddDailyGiftForm} from "@components/consumer/daily";
import withPage from "@components/hoc/withPage";

const AddDailyGiftPage: FC = () => (
    <AddDailyGiftForm />
)

export default withPage(AddDailyGiftPage);
